import axios from 'axios'

const GETSTORE = {
  data() {
    return {
      status: '',
      memberDetails: ''
    }
  },
  mounted() {
    this.determineAction()
  },
  methods: {
    determineAction() {
      /* If being passed data (clicking a thing), show the data and save
      * it to the store. If there's no data being passed (clicking back
      * or the breadcrumb, query the store). Different variable
      * depending on whether it's a parent or child profile page. */
      if (this.$route.params && this.$route.params.slug) { // Get ID from page slug
        this.getMemberFromAPI(this.$route.params.slug)
      } else if (this.details) { // Get ID from passed details prop
        this.getMemberFromAPI(this.details.id)
      } else if (this.userID) { // Get ID from passed ID of logged-in user
        this.getMemberFromAPI(this.userID)
      } else { // Else, get child ID
        this.memberDetails = this.child ? this.$store.state.childMember : this.$store.state.viewedMember

        if (this.memberDetails === '') { // Probably won't ever happen but if something goes wrong with the above, go back to root
          this.$router.push('/')
        }
      }
    },
    getMemberFromAPI(userID) {
      if (userID !== localStorage.userID || !this.$isAdmin) {
        let tempUser = []
        axios.get(`${this.$api}/user/${userID}`).then((response) => {
          if (response.data.status === 'success') {
            tempUser = response.data.data
            this.$store.commit('setMember', tempUser)
            // We're handling date of birth weirdly, just roll with it
            if (tempUser.dob) {
              tempUser.dateOfBirth = tempUser.dob
            }
          } else if (response.data.status === 'undefined_error') {
            this.$router.push({ name: 'Dashboard', params: { status: "That user couldn't be found." } })
          }

          if (tempUser === '') {
            this.$router.push('/')
          }
          this.status = response.data.status
          this.setUser(tempUser)
        })
      }
    },
    setUser(tempUser) {
      if (!tempUser.hasOwnProperty('attributes') || tempUser.attributes === null) {
        tempUser.attributes = { address: {} }
      } else if (!tempUser.attributes.hasOwnProperty('address') || tempUser.attributes.address === null) {
        tempUser.attributes.address = {}
      }

      if (this.child) {
        this.$store.commit('updateChildMember', tempUser)
      } else {
        this.$store.commit('updateViewedMember', tempUser)
      }
      this.memberDetails = tempUser
      this.memberDetails.getedRole = this.memberDetails.role
    }
  }
}

export default GETSTORE



// WEBPACK FOOTER //
// ./src/store/memberProfileStore.js